<template>
  <div>
    <v-card style="border-radius:12px;">
      <v-row class="px-5">
        <v-col cols='6' style="border-right: solid 1px #ccc" class="d-flex justify-center align-center">
          <v-icon v-if="category_icon" :color="category_icon.color">{{category_icon.icon}}</v-icon>
          <div :class="`${category_icon.color}--text`">
            {{item.code}} - {{item.name}}
          </div>
        </v-col>
        <v-col cols='6' align='center' style="border-left: solid 1px #ccc" align-self="center">
          <v-row>
            <v-col>
              <div class="display-1 font-weight-black">
                {{ current_grade }}
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pa-0 pb-3">
              <v-btn color="error" @click="current_grade--" :disabled="is_execution_closed || current_grade == 0" icon><v-icon large>mdi-minus-thick</v-icon></v-btn>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-btn color="primary" @click="current_grade++" :disabled="is_execution_closed" icon><v-icon large>mdi-plus-thick</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'CategoryCard',
  props: {
    item: {
      type: Object,
    },
    item_idx: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      local_item: {},
      current_grade: 0,
      dialog: false,
    }
  },
  methods: {
    handleSelected(e){
      this.current_grade = e
      this.dialog = false
    },
    handleClose(){
      this.dialog = false
    },
    setupLocalItem(){
      if (this.item){
        this.local_item = {...this.item}
      }
    },
    setupCurrentGrade() {
      if (this.current_answer) {
        this.current_grade = this.current_answer;
      }
    },
    setGrade(val){
      let obj = {
        category_idx: this.item_idx,
        category_id: this.local_item.id,
        time_idx: this.current_time_idx,
        grade: val,
      }
      console.log({obj});
      this.setGradeTimeModel2(obj)
    },
    ...mapActions({
      setGradeTimeModel2: 'Execution/setGradeTimeModel2'
    }),
    ...mapMutations({
      setCurrentTime: 'Execution/setCurrentTime',
    })
  },
  mounted () {
    this.setupLocalItem();
    this.setupCurrentGrade();
  },
  computed: {
    is_execution_closed() {
      let status = this.current_execution.done_at;
      if (status) {
        return true;
      } else {
        return false;
      }
    },
    current_answer() {
      console.log('item_idx'+this.item_idx);
      console.log('current_time_idx'+this.current_time_idx);
      console.log(this.current_execution.categories[this.item_idx].grade_time[this.current_time_idx])
      let answer = this.current_execution.categories[this.item_idx].grade_time[this.current_time_idx];
      answer = Number(answer)
      return answer
    },
    category_icon(){
      if (this.current_execution.categories){
        if (this.item){
          let icon_map = {
            I: {
              icon: 'mdi-trending-down',
              color: 'error',
            },
            P: {
              icon: 'mdi-trending-up',
              color: 'success',
            }
          }
          return icon_map[this.item.kind]
        }
      }
      return {
        icon: 'mdi-trending-neutral',
        color: 'grey',
      }
    },
    ...mapState({
      categories: state => state.Execution.categories,
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      current_time_idx: state => state.Execution.current_time_idx,
      profile: state => state.User.profile,
      // data: state=> state.Module.state_var
    }),
  },
  watch: {
    current_time_idx(nv, ov) {
      let idx = nv || 0
      this.loading = true
        setTimeout(() => {
          this.current_grade = this.current_execution.categories[this.item_idx].grade_time[idx] || 0
          this.loading = false
        }, 100);
      if(nv){
      }
    },
    current_time(nv, ov) {
      if(nv){
      }
    },
    current_grade(nv,ov){
      if (nv){
        this.setGrade(Number(nv))
      }
    }
  },

}
</script>

<style lang="scss" scoped>

</style>